
import { AxiosError } from 'axios';
import environment from '../../../../environments/environment';
import { axiosInterceptor } from '../authInterceptor';
import { ActualsChartIdReq, ActualSearch, AdminActualSearch, DownloadVO, ParticipantActualsExceptionsVO, ParticipantsFileColumnMappingsVO } from './financials';

const FORCASTLIST_FILTER_URL = environment.getBudgetActualListURL;
const FORCASTLIST_COUNT_URL = environment.getBudgetActualListCountURL;
const BUDGET_ACTUAL_DERAILS_CHART_URL = environment.getBudgetActualDetailsChartByFinacialYearandMonthURL;
const GET_PARTICIPANT_ACTUALS_STATUS_PARTICIPANTID_FINANCIAL_YEAR_MONTH_URL = environment.getParticipantActualsStatusByParticipantIdAndFinancialYearAndMonthURL;
const UPDATE_STATUS_AND_ACTUAL_SUBMISSION_DATE_BY_PARTICIPANTID_AND_FINANCIAL_YEAR_AND_MONTH_URL = environment.updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearAndMonthURL;
const GET_PARTICIPANT_ACTUALS_EXCEPTIONS_BY_PARTICIPANT_URL = environment.getParticipantActualsExceptionsByParticipantURL;
const GET_ACTUALS_DERAILS_TO_DOWNLOAD_URL = environment.getActualDetailsTODownloadURL;
const GET_BUDGET_ACTUAL_DERAILS_SUB_CHART_FINANCIAL_YEAR_URL = environment.getBudgetActualDetailsSubChartByFinacialYearURL;
const POST_PARTICIPANT_ACTUAL_EXCEPTIONS_URL = environment.postParticipantActualsExceptionsURL;
const POST_PARTICIPANT_FILE_MAPPING_URL = environment.postParticipantFileMappingURL;
const POST_ACTUALS_CHART_ACCOUNTS_TRANSACTIONS_URL = environment.postActualsChartAccountsTransactionsURL;


export async function getActualSearchCount(actualSearch: ActualSearch) {
  try {
    const countResponse = await axiosInterceptor.post(`${FORCASTLIST_COUNT_URL}`, actualSearch);
    return countResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getActualInfoList(actualSearch: ActualSearch) {
  try {
    const getAllBudgetInfoListResponse = await axiosInterceptor.post(`${FORCASTLIST_FILTER_URL}`, actualSearch);
    return getAllBudgetInfoListResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getAdminActualSearchCount(actualSearch: AdminActualSearch) {
  try {
    const countResponse = await axiosInterceptor.post(`${FORCASTLIST_COUNT_URL}`, actualSearch);
    return countResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getAdminActualInfoList(actualSearch: AdminActualSearch) {
  try {
    const getAllActualInfoListResponse = await axiosInterceptor.post(`${FORCASTLIST_FILTER_URL}`, actualSearch);
    return getAllActualInfoListResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function getBudgetActualDetailsChartAccountsByYearAndParticipantIdURL(forecastYear: string, participantId: number, clientId: number) {
  try {
    const getBudgetActualDetailsChartAccountsByYearAndParticipantIdResponse = await axiosInterceptor.get(`${BUDGET_ACTUAL_DERAILS_CHART_URL}financial-year/${forecastYear}/participant-id/${participantId}/month/All?clientId=${clientId}`);
    return getBudgetActualDetailsChartAccountsByYearAndParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getParticipantActualsStatusByParticipantIdAndFinancialYearAndMonth(participantId: number, financialYear: string, month: string, clientId: number) {
  try {
    const getChartAccountsByYearAndParticipantIdResponse = await axiosInterceptor.get(`${GET_PARTICIPANT_ACTUALS_STATUS_PARTICIPANTID_FINANCIAL_YEAR_MONTH_URL}${participantId}/financial-year/${financialYear}/month/${month}?clientId=${clientId}`);
    return getChartAccountsByYearAndParticipantIdResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearAndMonth(status: string, participantId: number, financialYear: string, month: string ) {
  try {
    const updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearAndMonthResponse = await axiosInterceptor.post(`${UPDATE_STATUS_AND_ACTUAL_SUBMISSION_DATE_BY_PARTICIPANTID_AND_FINANCIAL_YEAR_AND_MONTH_URL}${status}/participant-id/${participantId}/financial-year/${financialYear}/month/${month}`);
    return updateStatusAndActualSubmissionDateByParticipantIdAndFinancialYearAndMonthResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function participantActualsExceptionsByParticipant(participantId: number, clientId: number) {
  try {
    const participantActualsExceptionsByParticipantResponse = await axiosInterceptor.get(`${GET_PARTICIPANT_ACTUALS_EXCEPTIONS_BY_PARTICIPANT_URL}${participantId}?clientId=${clientId}`);
    return participantActualsExceptionsByParticipantResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getBudgetActualDetailsSubChartByFinacialYear(rowId: number, month: string, participantId: number, financialYear: string, clientId: number) {
  try {
    const getBudgetActualDetailsSubChartByFinacialYearResponse = await axiosInterceptor.get(`${GET_BUDGET_ACTUAL_DERAILS_SUB_CHART_FINANCIAL_YEAR_URL}rowId/${rowId}/month/${month}/participant-id/${participantId}/financial-year/${financialYear}?clientId=${clientId}`);
    return getBudgetActualDetailsSubChartByFinacialYearResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getActualDetailsTODownload(downloadVO: DownloadVO) {
  try {
    const getActualDetailsTODownloadResponse = await axiosInterceptor.post(`${GET_ACTUALS_DERAILS_TO_DOWNLOAD_URL}`, downloadVO);
    return getActualDetailsTODownloadResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postParticipantActualsExceptions(participantActualsExceptionsVO: ParticipantActualsExceptionsVO) {
  try {
    const postParticipantActualsExceptionsResponse = await axiosInterceptor.post(`${POST_PARTICIPANT_ACTUAL_EXCEPTIONS_URL}`, participantActualsExceptionsVO);
    return postParticipantActualsExceptionsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postParticipantFileMapping(participantsFileColumnMappingsVO: ParticipantsFileColumnMappingsVO) {
  try {
    const postParticipantFileMappingResponse = await axiosInterceptor.post(`${POST_PARTICIPANT_FILE_MAPPING_URL}`, participantsFileColumnMappingsVO);
    return postParticipantFileMappingResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function postActualsChartAccountsTransactions(actualsChartIdReq: ActualsChartIdReq) {
  try {
    const postActualsChartAccountsTransactionsResponse = await axiosInterceptor.post(`${POST_ACTUALS_CHART_ACCOUNTS_TRANSACTIONS_URL}`,actualsChartIdReq );
    return postActualsChartAccountsTransactionsResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}